<template>
  <div>
    <div class="dropdown bg-gray text-black w-[280px] ">
      <select
        @change="addUser"
        class="w-full text-[14px] !px-[20px] !py-[12px] !border-none !bg-gray"
      >
        <option value="">選択してください</option>
        <template v-for="{ user_id, value } in options">
          <option :value="user_id" :key="user_id">{{ value }}</option>
        </template>
      </select>
    </div>
    <div class="flex flex-wrap">
      <template v-for="{ user_id, user_name } in names">
        <div
          :key="user_id"
          class="bg-gray rounded-[4px] mr-[8px] mt-[8px] overflow-hidden flex"
        >
          <span
            class="inline-block py-[3px] pl-[10px] pr-[4px] text-[12px] text-bold"
          >
            {{ user_name }}
          </span>
          <button
            type="button"
            class="inline-block h-full rounded-none relative hover bg-transparent hover:bg-red"
            @click="removeUser(user_id)"
          >
            <i
              class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45 bg-black w-[2px] h-[8px]"
            />
            <i
              class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45 bg-black w-[8px] h-[2px]"
            />
          </button>
          <input type="hidden" name="request_member[]" :value="user_id" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initUsers: Array,
    selectedUsers: Array,
  },
  data() {
    const { initUsers = [], selectedUsers = [] } = this;
    return {
      selection: [...initUsers],
      selected: selectedUsers.map(({ user_id }) => user_id),
    };
  },
  computed: {
    options() {
      const { selection, selected } = this;
      return selection.filter(({ user_id }) => !selected.includes(user_id));
    },
    names() {
      const { selection, selected } = this;
      return selected.map(id =>
        selection.find(({ user_id }) => user_id === id)
      );
    },
  },
  methods: {
    addUser(ev) {
      console.log('+ev.target.value', +ev.target.value);
      this.selected = [+ev.target.value, ...this.selected];
    },
    removeUser(id) {
      this.selected = this.selected.filter(user_id => user_id !== id);
    },
  },
};
</script>

<!--

  *------------------------ 使用手順 ------------------------*


-->
<!-- <template>
     <div>
     <input
     class="el_input"
     type="text"
     v-on:key="addItem"
     v-data-list="users"
     v-model="input"
     placeholder="受講者を選択"
     />
     <button
     class="el_btn_white_largeBorder mt-[10px]"
     type="button"
     v-on:click="addItem"
     style="padding:6px 12px"
     >
     追加
     </button>

     <ul>
     <li
     class="inline-flex items-center flex justify-between"
     v-for="(selectUser, index) in selectUsers"
     v-bind:key="index"
     >
     {{ selectUser.user_name }}
     <button
     type="button"
     v-on:click="deleteItem(index)"
     class="el_btn_white_largeBorder ml-[10px]"
     >
     削除
     </button>
     <input
     type="hidden"
     name="request_member[]"
     v-bind:value="selectUser.user_id"
     />
     </li>
     </ul>
     </div>
     </template> -->

<!-- <script>
     export default {
     props: ['initUsers', 'initPrice', 'selectedUsers'],
     directives: { 'data-list': dataListDirective },
     data() {
     console.log('initUsers', this.initUsers);
     console.log('initPrice', this.initPrice);
     console.log('selectedUsers', this.selectedUsers);
     return {
     input: '',
     price: this.initPrice,
     users: this.initUsers,
     selectUsers: this.selectedUsers ?? [],
     };
     },
     methods: {
     addItem(e) {
     e.preventDefault();

     if (e.keyCode == 13 || e.type == 'click') {
     for (let user of this.users) {
     if (user.value == this.input) {
     for (let selectUser of this.selectUsers) {
     if (selectUser.value == this.input) {
     this.input = '';
     alert('すでに追加済みです');
     return false;
     }
     }
     this.selectUsers.push(user);
     this.input = '';
     // document.querySelector('#price_sum').innerText = (this.selectUsers.length * this.price).toLocaleString()
     break;
     }
     }
     }
     },
     deleteItem(index) {
     this.selectUsers.splice(index, 1);
     // document.querySelector('#price_sum').innerText = (this.selectUsers.length * this.price).toLocaleString()
     },
     },
     mounted() {
     // document.querySelector('#price_sum').innerText = (this.selectUsers.length * this.price).toLocaleString()
     },
     };
     </script>
     <style lang="scss" scoped>
     .el_btn_white_largeBorder {
     padding: 6px;
     }
     </style> -->
